import React, { useState, useEffect } from 'react';
import { Input, Label } from '../../css/Shared';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import States from '../../components/States';
import api from '../../components/Api';
import { toast } from 'react-toastify';
import FacilitySearchSelect from '../../components/SearchableSelect';

const PermitForm = ({
  onClose,
  permit,
  setPermits,
  reset,
  setReset,
  editPermitItemId,
  onCreated,
   normalizedFacilities
}) => {
  const { authState, axiUrl } = useAppContext();


  const [formData, setFormData] = useState({
    permitName: '',
    companyName: '',
    address: '',
    address2: '',
    city: '',
    state: 'FL',
    zip: '',
    permitType: 'Indicia',
    permitNumber: '',
    dueNetNumber: '',
    accountNumber: '',
       bmeuFacility: null,  
    company: authState?.user.company,
  });

  const [filteredBmeus, setFilteredBmeus] = useState();

  useEffect(() => {
    if (permit) {
      setFormData({ ...permit, company: authState?.user.company });
    }
  }, [permit]);
useEffect(() => {
  if (!permit) return;

  // If editing and facilities are loaded
  if (normalizedFacilities?.length) {
    const facilityId = permit?.bmeuFacility?.dropkey || permit?.bmeuFacility || null;

    const selectedFacility = normalizedFacilities.find(
      f => String(f.dropkey) === String(facilityId)
    ) || null;

    setFormData({
      ...permit,
      bmeuFacility: selectedFacility,
      company: authState?.user.company
    });
  } else {
    // fallback if facilities not loaded yet
    setFormData({
      ...permit,
      company: authState?.user.company
    });
  }
}, [permit, normalizedFacilities]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const handleSubmit = async e => {
  e.preventDefault();
const isUpdate = Boolean(permit);

  try {
    const endpoint = permit
      ? '/permits/updatepermitholders'
      : '/permits/addpermitholder';

const basePayload = {
  ...formData,
  bmeuFacility: formData.bmeuFacility|| null
};

const payload = permit
  ? { ...basePayload, id: permit?._id }
  : basePayload;

    console.log("SENDING", payload);

    //await api.post(endpoint, payload);
const res = await api.post(endpoint, payload);
console.log('NEW / UPDATED PERMIT:', res.data);
 toast.success(isUpdate ? 'Permit updated' : 'Permit saved');
  if (onCreated) {
   onCreated(res.data);
  }
  if (!onCreated && typeof setPermits === 'function') {
  setPermits([]);
}
    if (!onCreated && typeof setPermits === 'function') {
  setReset(!reset);
}
  onClose();   // <— move this UP for testing

  } catch (err) {
    console.error("FAILED", err.response?.data || err.message);
  }
};
   
//   const handleSubmit = async e => {
//   e.preventDefault();

//   try {
//     const endpoint = permit
//       ? '/permits/updatepermitholders'
//       : '/permits/addpermitholder';

//     const payload = permit
//       ? { ...formData, id: permit._id }
//       : formData;

//     await api.post(endpoint, payload);

//     setPermits([]);
//     setReset(prev => !prev);
// onClose();
//   } catch (err) {
//     console.error(err);
//   }
// };
console.log("FACILITIES:", normalizedFacilities);
  return (
    <div
      className="
        max-h-[80vh]
        overflow-y-auto
        max-w-6xl
        mx-auto
        px-6
        py-4

        text-sm
        [&_input]:h-9
        [&_input]:text-sm
        [&_input]:px-3
        [&_label]:text-xs
      "
    >
      <form onSubmit={handleSubmit} className="space-y-6">

        {/* HEADER */}
        <h2 className="text-base font-semibold text-gray-800">
          {permit ? 'Edit Permit' : 'New Permit'}
        </h2>

        {/* PERMIT NAME */}
        <InputGroup
          label="Permit name"
          name="permitName"
          {...formData}
          onChange={handleChange}
        />

        {/* OWNER */}
     <Section title="Owner">
  <div className="grid grid-cols-1 md:grid-cols-6 gap-4">

    {/* Company (full width) */}
    <div className="md:col-span-6">
      <InputGroup
        label="Company"
        name="companyName"
        {...formData}
        onChange={handleChange}
      />
    </div>

    {/* Address 1 + Address 2 (same row on desktop) */}
    <div className="md:col-span-3">
      <InputGroup
        label="Address 1"
        name="address"
        {...formData}
        onChange={handleChange}
      />
    </div>

    <div className="md:col-span-3">
      <InputGroup
        label="Address 2"
        name="address2"
        {...formData}
        onChange={handleChange}
      />
    </div>

    {/* City */}
    <div className="md:col-span-3">
      <InputGroup
        label="City"
        name="city"
        {...formData}
        onChange={handleChange}
      />
    </div>

    {/* State */}
    <div className="md:col-span-1">
      <Label muted>State</Label>
      <States setFormData={setFormData} formData={formData} />
    </div>

    {/* Zip */}
    <div className="md:col-span-2">
      <InputGroup
        label="Zip"
        name="zip"
        {...formData}
        onChange={handleChange}
      />
    </div>

  </div>
</Section>


        {/* PERMIT TYPE */}
        <Section title="Permit type">
          <div className="flex flex-wrap gap-6">
            {['Indicia', 'Stamp', 'Meter']?.map(type => (
              <label key={type} className="flex items-center gap-2 text-xs">
                <input
                  type="radio"
                  name="permitType"
                  value={type}
                  checked={formData.permitType === type}
                  onChange={handleChange}
                  className="scale-90"
                />
                {type}
              </label>
            ))}
          </div>
        </Section>

        {/* DETAILS */}
        <Section title="Details">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <InputGroup label="Permit #" name="permitNumber" {...formData} onChange={handleChange} />
            <InputGroup label="Net due #" name="dueNetNumber" {...formData} onChange={handleChange} />
            <InputGroup label="Account #" name="accountNumber" {...formData} onChange={handleChange} />
          </div>

          <div className="mt-4">
            <Label muted>Post Office of Permit</Label>
               <FacilitySearchSelect
      facilities={normalizedFacilities}
      value={formData.bmeuFacility}
      onChange={(facility) =>
        setFormData(prev => ({
          ...prev,
          bmeuFacility: facility
        }))
      }
    />
            {/* <Input
              name="bmeu"
              value={formData.bmeu}
              onChange={handleChange}
              list="bmeu-options"
            />
            <datalist id="bmeu-options">
              {filteredBmeus?.map((b, i) => (
                <option key={i} value={`${b.address}, ${b.city} ${b.zIP}`} />
              ))}
            </datalist> */}
          </div>
        </Section>

        {/* ACTIONS */}
        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>

      </form>
    </div>
  );
};

/* ---------- helpers ---------- */

const Section = ({ title, children }) => (
  <section className="border rounded-lg p-4">
    <h3 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wide">
      {title}
    </h3>
    {children}
  </section>
);

const InputGroup = ({ label, name, onChange, ...data }) => (
  <div>
    <Label muted>{label}</Label>
    <Input name={name} value={data[name]} onChange={onChange} />
  </div>
);

export default PermitForm;
